import * as React from 'react';
import {Route} from 'react-router-dom';

import type {ReportKey} from '../../reports/report-types';
import {UrlParamsWrapper} from '../../routes/utils';

export type Props = {
    path: string;
    // If we want to set an explicit key for the localStorage
    localStorageKey?: string;
    reportKey?: ReportKey;
    // If we need an initial filter for the page, we pass the key so we can build
    // that initial filter (e.g. {sentEditions: '6-emEditions'})
    initialFilterKey?: string;
    // The param used to get the id from the url, used in the initialFilter if
    // initialFilterKey is passed and also passed to the component if needed
    idParam?: string;
    component: React.ComponentType<any>;
};

export const PageRoute = (props: Props) => (
    <Route
        path={props.path}
        render={(routeProps) => {
            const Component = props.component;

            // @ts-expect-error
            const id: string =
                props.idParam && routeProps.match.params[props.idParam]
                    ? routeProps.match.params[props.idParam]
                    : '';

            const initialFilter = props.initialFilterKey
                ? {[props.initialFilterKey]: id}
                : undefined;

            return (
                <UrlParamsWrapper
                    routeProps={routeProps}
                    reportKey={props.reportKey}
                    initialFilter={initialFilter}
                    localStorageKey={props.localStorageKey}
                >
                    {({
                        urlParams,
                        activeFilters,
                        onParamChange,
                        onParamPush,
                        onRemoveAllFilters,
                    }) => (
                        <Component
                            {...routeProps}
                            id={id}
                            urlParams={urlParams}
                            activeFilters={activeFilters}
                            onParamChange={onParamChange}
                            onParamPush={onParamPush}
                            onRemoveAllFilters={onRemoveAllFilters}
                        />
                    )}
                </UrlParamsWrapper>
            );
        }}
    />
);
